import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  AccountNav,
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';

export function Users() {
  const { setModal } = useContext(ModalContext);
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const context = useContext(ViewContext);

  const format = new DateUtils();

  async function runAPI(page, search) {
    setLoading(true);

    const current_agency = await axios.get('/api/account');

    await axios
      .get('/api/user/search', {
        params: {
          page: page,
          search: search,
          agency_id: current_agency.data.data.id
        }
      })
      .then(async (r) => {
        setLoading(false);
        setPayload(r.data.data);

        var tempData = [];

        const timezone = await format.getTimezone();

        r.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            name: value.name,
            email: value.email,
            'Created At': format.timestamp(
              value.date_created,
              timezone
            ),
            status: value.disabled ? 'Inactive' : 'Active',
          });
        });

        setData(tempData);
      })
          .catch((err) => {
            console.log(err);
            context.notification.show(
              'Failed to load company infos',
              'error',
              true,
              'toast',
              'x-circle'
            );
          });
      }

  useEffect(() => {
        runAPI(page, searchQueryString);
      }, [searchQueryString]);

    useEffect(() => {
      runAPI(page, searchQueryString);
    }, []);

    return (
      <Animate type="pop">
        <AccountNav />
        <div
          style={{
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <IconedButton
              size="140px"
              color="#d32425"
              textColor="white"
              icon="plus-circle"
              text="Add User"
              marginRight
              action={() => {
                setModal({
                  name: 'user_modal',
                });
              }}
            />
          </div>
        </div>
        <Grid cols="1">
          <div className={styles.wrapper}>
            <div style={{ marginBottom: 10 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              data={data}
              hide={['id']}
              loading={loading}
              badge={{
                col: 'status',
                condition: [
                  { value: 'Active', color: 'green' },
                  { value: 'Inactive', color: 'red' },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page ? payload.page : 1}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </Grid>
      </Animate>
    );
  }
